import EditInventorySite from '../Modals/Inventory/EditInventorySite';
import EditInventoryAsset from '../Modals/Inventory/EditInventoryAsset';
import AddOwner from '../Modals/Inventory/AddOwner';
import UpdateSla from '../Modals/Inventory/UpdateSla';
import MigrateAsset from '../Modals/Inventory/MigrateAsset';
import ReplaceAsset from '../Modals/Inventory/ReplaceAsset';
import EditCategoriseAsset from '../Modals/Inventory/EditCategoriseAsset';
import EditInventoryWarehouse from '../Modals/Inventory/EditInventoryWarehouse';
import EditInventorySpareAsset from '../Modals/Inventory/EditInventorySpareAsset';
import AddSpareAsset from '../Modals/Inventory/AddSpareAsset';
import DownloadQR from '../Modals/Inventory/DownloadQR';
import ScrapAsset from '../Modals/Inventory/ScrapAsset';
import UploadFile from '../Modals/Inventory/UploadFile';
import AddAssetTypes from '../Modals/Inventory/AddAssetTypes';
import ApproveRmaSupport from '../Modals/Inventory/ApproveRmaSupport';
import CreateReconcileTicketSpareAsset from '../Modals/Inventory/CreateReconcileTicketSpareAsset';
import CreateSupportTicket from '../Modals/Inventory/CreateSupportTicket';
import { openCustomModal, openTextModalAction, closeModalAction } from '../../actions/modal';
import {
    deleteInventorySite,
    deleteInventoryWarehouse,
    bulkUploadSpareAssets,
    deleteAsset,
    deleteLocation,
} from '../../actions/inventory';
import { isScm, isCustomer, isCustomerAdmin, isCustomerUser, isCluster, isPsp, isSuperVisor, isSp, isFe, isIsp, isSpIsp } from '../../utils/role';
import { useSelector } from 'react-redux';
import DownloadReport from '../Modals/Inventory/DownloadReport';
import { sendToastMessage } from '../../actions/toast';
import DownloadBulkQR from '../Modals/Inventory/DownloadBulkQR';
import { isArrayElementsSame } from '../../utils/common';
import AddAsset from '../Ticket/Modal/AddAsset';
import ViewAssetConfig, { assetConfigModalSize } from '../Ticket/Modal/ViewAssetConfig';
import ViewPavData from '../Modals/Inventory/ViewPavData';
import AccordionJSON from './reusableComponents/AccordionJSON';
import ButtonScogoOrange from '../../common/Buttons/ButtonScogoOrange';
import BulkUploadModal from '../Ticket/Modal/BulkUploadModal';
import RequestStatement from '../Wallet/Modals/RequestStatement';
import { isMobileView, ReportsName } from '../../utils/utils';
import { canCreateInventoryAsset, canCreateInventoryLocation } from '../../utils/access';
import { TicketAgentRole } from '../Ticket/TicketController';

// Sites Table Actions
const editSite = {
    key: 'edit_site',
    menuName: 'Edit Site',
    menuIcon: 'save_as',
    onClick: (site, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Edit Site',
                modalWidth: isMobileView ? '36rem' : '90rem',
                modalHeight: 'auto',
                modalComponent: <EditInventorySite modalData={site} />,
            })
        );
    },
};

const updateSla = {
    key: 'update_sla',
    menuName: 'Update SLA',
    menuIcon: 'app_registration',
    onClick: (site, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Update SLA',
                modalWidth: '50rem',
                modalHeight: 'auto',
                modalComponent: <UpdateSla modalData={site} customerId={customerId} />,
            })
        );
    },
};

const addAsset = {
    key: 'add_asset',
    menuName: 'Add Asset',
    menuIcon: 'list',
    onClick: (site, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Add Asset',
                modalWidth: isMobileView ? '36rem' : '95rem',
                modalHeight: 'auto',
                modalComponent: <AddAsset location={site} location_id={site.id} org_id={site.org_id} />,
            })
        );
    },
};

const raiseSupportTicket = {
    key: 'create_ticket',
    menuName: 'Create Ticket',
    menuIcon: 'confirmation_number',
    onClick: (site, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Raise Support Ticket',
                modalWidth: '90rem',
                modalHeight: 'auto',
                modalComponent: <CreateSupportTicket modalData={site} customerId={customerId} />,
            })
        );
    },
};

const deleteSiteModal = {
    key: 'delete_site',
    menuName: 'Delete Site',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (site, dispatch, { customerId }) => {
        const formName = 'deleteSite';
        return dispatch(
            openTextModalAction({
                heading: 'Delete Site',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        onClick: () => {
                            dispatch(deleteLocation({ id: site?.id, formName }));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
};

// Assets Table Actions

const addOwner = {
    key: 'add_owner',
    menuName: 'Add Owner',
    menuIcon: 'add_business',
    onClick: (asset, dispatch, { siteId, customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Add Owner',
                modalWidth: '44rem',
                modalHeight: 'auto',
                modalComponent: <AddOwner modalData={asset} customerId={customerId} siteId={siteId} />,
            })
        );
    },
};

const replaceAsset = {
    key: 'replace_asset',
    menuName: 'Replace Asset',
    menuIcon: 'find_replace',
    onClick: (asset, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Replace Asset',
                modalWidth: '50rem',
                modalHeight: 'auto',
                modalComponent: <ReplaceAsset modalData={asset} customerId={customerId} />,
            })
        );
    },
};

const categoriseAsset = {
    key: 'categorize_asset',
    menuName: 'Categorise Asset',
    menuIcon: 'category',
    onClick: (asset, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Categorise Asset',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: <EditCategoriseAsset modalData={{ assetslist: [asset] }} customerId={customerId} />,
            })
        );
    },
    isDisabled: (asset) => {
        return { disabled: asset?.is_categorised !== 0, message: 'Not allowed to modify warehouse' };
    },
};

const assetRaiseSupportTicket = {
    key: 'create_tickets',
    menuName: 'Create Tickets',
    menuIcon: 'confirmation_number',
    onClick: (asset, dispatch, { customerId, siteId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Raise Support Ticket',
                modalWidth: '90rem',
                modalHeight: 'auto',
                modalComponent: <CreateSupportTicket modalData={asset} customerId={customerId} siteId={siteId} />,
            })
        );
    },
};


const scrapAsset = {
    key: 'scrap_asset',
    menuName: 'Scrap Asset',
    menuIcon: 'backup',
    divider: true,
    onClick: (asset, dispatch, { customerId, tabName, siteId }) => {
        return dispatch(
            openCustomModal({
                heading: `Scrap Asset | ${getAssetTitle(asset)}`,
                modalWidth: '45rem',
                modalHeight: 'auto',
                modalComponent: <ScrapAsset modalData={{ assetslist: [asset] }} customerId={customerId} modalName={tabName} siteId={siteId} />,
            })
        );
    },
    isDisabled: (asset) => {
        return { disabled: asset?.is_archived !== 0, message: 'Scrap asset not archived' };
    },
};

const EditConfigButton = ({ asset, dispatch }) => {
    return <ButtonScogoOrange textOrComponent={`${isDeviceConfigurationRequired(asset) ? "Edit Config" : "Device Files"}`} onClick={() => editAssetConfig.onClick(asset, dispatch)} />
}


const editAsset = {
    key: 'edit_asset',
    menuName: 'Edit Asset',
    menuIcon: 'save_as',
    onClick: (asset, dispatch, { siteId, customerId }) => {

        return dispatch(
            openCustomModal({
                heading: (
                    <span className='text-black'>
                        Edit Asset | <span className='text-scogobgsky text-font16'>{getAssetTitle(asset)}</span>
                    </span>
                ),
                modalWidth: isMobileView ? '36rem' : '90rem',
                modalHeight: 'auto',
                modalComponent: <EditInventoryAsset modalData={asset} customerId={customerId} siteId={siteId} renderButtons={<EditConfigButton asset={asset} dispatch={dispatch} />} />,
            })
        );
    },
};



const editAssetConfig = {
    key: 'edit_config',
    conditionalRendering: (asset, _) => {
        if (isDeviceConfigurationRequired(asset)) return { menuName: 'Asset Config', menuIcon: 'settings_applications', iconColor: 'text-scogogray' };
        return { menuName: 'Device Files', menuIcon: 'settings_applications', iconColor: 'text-scogogray' };
    },
    onClick: (asset, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: (
                    <span className='text-black'>
                        Edit Asset Config | <span className='text-scogobgsky text-font16'>{getAssetTitle(asset)}</span>
                    </span>
                ),
                modalWidth: '70rem',
                modalHeight: '84vh',
                maxHeight: '84vh',
                modalComponent: <AccordionJSON asset={asset} assetId={asset.id} serial_number={asset.serialNo} showJsonEditor={isDeviceConfigurationRequired(asset)} enduserId={asset.enduserId} />,
            })
        );
    },
};

const viewAssetConfig = {
    key: 'view_asset_config',
    menuName: 'View/Edit Config',
    menuIcon: 'visibility',
    iconColor: 'text-scogoprimary',
    onClick: (asset, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'View/Edit Config',
                ...assetConfigModalSize,
                modalComponent: <ViewAssetConfig assetId={asset?.asset_id || asset?.id} asset={asset?.asset || asset} />,
            })
        );
    },
};

const viewPavData = {
    key: 'view_pav_data',
    menuName: 'View PAV Data',
    menuIcon: 'fact_check',
    iconColor: 'text-scogoprimary',
    onClick: (asset, dispatch) => {
        const serialNumber = asset?.asset?.serial_number;
        return dispatch(
            openCustomModal({
                heading: (
                    <span className='text-black'>
                        View PAV Data{serialNumber && <> | <span className='text-scogobgsky text-font16'>{serialNumber}</span></>}
                    </span>
                ),
                modalWidth: 'min(70rem, 95vw)',
                modalHeight: 'auto',
                maxHeight: '80vh',
                modalComponent: <ViewPavData assetId={asset?.asset_id || asset?.asset?.id} ticket={asset?.ticket} />,
            })
        );
    },
};

const deleteAssetData = {
    key: 'delete_asset',
    menuName: 'Delete Asset',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (asset, dispatch, { customerId }) => {
        const formName = 'deleteAssetData';
        return dispatch(
            openTextModalAction({
                heading: `Delete Asset | ${getAssetTitle(asset)}`,
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        onClick: () => {
                            dispatch(deleteAsset({ id: asset.asset_id, formName }))
                        },
                        buttonClass: 'hover:bg-scogoLightFillRed',
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
};

//warehouse
const editWarehouse = {
    key: 'edit_warehouse',
    menuName: 'Edit Warehouse',
    menuIcon: 'save_as',
    onClick: (warehouse, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Edit Warehouse',
                modalWidth: isMobileView ? '36rem' : '90rem',
                modalHeight: 'auto',
                modalComponent: <EditInventoryWarehouse modalData={warehouse} customerId={customerId} />,
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const addSpareAsset = {
    key: 'add_spare_asset',
    menuName: 'Add Spare Assets',
    menuIcon: 'queue_play_next',
    onClick: (location, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Add Spare Assets',
                modalWidth: isMobileView ? '36rem' : '90rem',
                modalHeight: 'auto',
                modalComponent: <AddSpareAsset location={location} location_id={location.id} org_id={location.org_id} />,
            })
        );
    },
    isDisabled: (warehouse) => {
        return { disabled: false, message: '' };
    },
};

const isToOpenModal = (selectedData) => {
    let isItemsSelected = Array.isArray(selectedData) && selectedData.length > 0;
    let toastErrorMsg = '';

    let customerIdsOfSpareAssets = Array.isArray(selectedData) && selectedData.map((spareasset) => spareasset?.customer_id);
    let warehouseIdsOfSpareAssets = Array.isArray(selectedData) && selectedData.map((spareasset) => spareasset?.warehouse?.id);

    if (!isItemsSelected) {
        toastErrorMsg = 'Please select atleast one';
    } else {
        if (!isArrayElementsSame(customerIdsOfSpareAssets)) {
            toastErrorMsg = 'Multiple customer assets found';
        }
        if (!isArrayElementsSame(warehouseIdsOfSpareAssets)) {
            toastErrorMsg = 'Multiple warehouse assets found';
        }
    }

    let openModal = isItemsSelected && isArrayElementsSame(customerIdsOfSpareAssets) && isArrayElementsSame(warehouseIdsOfSpareAssets);

    return { toastErrorMsg, openModal };
};

const createReconcilationTicketSpareAsset = {
    key: 'create_reconcilation_ticket_spareasset',
    menuName: 'Create Reconcilation Ticket',
    menuIcon: 'confirmation_number',
    divider: true,
    onClick: (warehouse, dispatch, { warehouseId, siteId, customerId, getSelectedData }) => {
        let selectedData = getSelectedData();
        let { openModal, toastErrorMsg } = isToOpenModal(selectedData && selectedData);
        if (openModal) {
            return dispatch(
                openCustomModal({
                    heading: 'Create Reconcilation Ticket',
                    modalWidth: '90rem',
                    modalHeight: 'auto',
                    modalComponent: (
                        <CreateReconcileTicketSpareAsset
                            modalData={{ assetslist: selectedData }}
                            customerId={customerId}
                            warehouseId={warehouseId}
                            siteId={siteId}
                            warehouse={warehouse}
                        />
                    ),
                })
            );
        } else {
            dispatch(sendToastMessage({ status: 'danger', message: toastErrorMsg }));
        }
    },
};

const deleteWarehouseModal = {
    key: 'delete_warehouse',
    menuName: 'Delete Warehouse',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (warehouse, dispatch, { customerId }) => {
        const formName = 'deleteWarehouse';
        return dispatch(
            openTextModalAction({
                heading: 'Delete Warehouse',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        onClick: () => {
                            dispatch(deleteLocation({ id: warehouse?.id, formName }));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                        buttonClass: 'hover:bg-scogobgsky',
                    },
                ],
            })
        );
    },
    isDisabled: (warehouse) => {
        return { disabled: false, message: '' };
    },
};

//spareAssets

const editAssetModal = {
    key: 'edit_spareasset',
    menuName: 'Edit Spare Asset',
    menuIcon: 'save_as',
    onClick: (asset, dispatch, { customerId, warehouseId }) => {
        return dispatch(
            openCustomModal({
                heading: `Edit Spare Asset | ${getAssetTitle(asset)}`,
                modalWidth: isMobileView ? '36rem' : '90rem',
                modalHeight: isMobileView ? '84vh' : 'auto',
                modalComponent: <EditInventoryAsset modalData={asset} renderButtons={<EditConfigButton asset={asset} />} />,
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const migrateAsset = {
    key: 'migrate_asset',
    menuName: 'Migrate Asset',
    menuIcon: 'move_up',
    onClick: (asset, dispatch, { customerId }) => {
        const warehouseId = asset?.asset?.id;
        const siteId = asset?.location_id;
        return dispatch(
            openCustomModal({
                heading: `Migrate Asset`,
                modalWidth: isMobileView ? '36rem' : '85rem',
                modalHeight: 'auto',
                modalComponent: <MigrateAsset modalData={{ assetslist: [asset] }} warehouseId={warehouseId} siteId={siteId} />,
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const requestRmaSupport = {
    key: 'request_rma_support',
    menuName: 'Request Rma support',
    menuIcon: 'list',
    onClick: (asset, dispatch, { customerId }) => {
        const siteId = asset?.fk_site_id > 0 ? asset?.fk_site_id : 0;
        return dispatch(
            openCustomModal({
                heading: 'Request RMA Support',
                modalWidth: '64rem',
                modalHeight: 'auto',
                modalComponent: <ApproveRmaSupport modalData={{ assetslist: [asset] }} customerId={customerId} rmaEligibility={'RMA_ELIGIBILITY_REQUEST'} siteId={siteId} />,
            })
        );
    },
};

const approveRmaSupport = {
    key: 'approve_rma_support',
    menuName: 'Approve Rma support',
    menuIcon: 'list',
    onClick: (asset, dispatch, { customerId }) => {
        const siteId = asset?.fk_site_id > 0 ? asset?.fk_site_id : 0;
        return dispatch(
            openCustomModal({
                heading: 'Approve RMA Support',
                modalWidth: '64rem',
                modalHeight: 'auto',
                modalComponent: <ApproveRmaSupport modalData={{ assetslist: [asset] }} customerId={customerId} rmaEligibility={'RMA_ELIGIBILITY_APPROVE'} siteId={siteId} />,
            })
        );
    },
    isDisabled: (asset) => {
        return { disabled: asset?.is_rma_eligible !== 0, message: 'Not eligible to approve' };
    },
};

const deleteSpareAssetModal = {
    key: 'delete_spareasset',
    menuName: 'Delete Spare Asset',
    menuIcon: 'delete',
    iconColor: 'text-scogoclosed',
    onClick: (asset, dispatch, { customerId, warehouseId }) => {
        const formName = 'deleteSpareAsste';
        return dispatch(
            openTextModalAction({
                heading: 'Delete Spare Asset',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName,
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        // onClick: () => {
                        //     // dispatch(deleteInventorySpareAsset({ assetId: spareAssetID, customerId, warehouseId, formName }));
                        //     // dispatch(deleteAssetData({ id: asset?.id }))
                        // },
                        onClick: () => {
                            // dispatch(deleteInventoryAsset({ assetId: asset.id, customerId, formName, enduserId: asset.enduserId }));
                            dispatch(deleteAsset({ id: asset.asset_id }))
                        }
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => {
                            dispatch(closeModalAction());
                        },
                    },
                ],
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

//header bulk actions
const bulkUploadSite = {
    key: 'bulk_site_modal',
    menuName: 'Bulk Upload Site',
    menuIcon: 'inventory',
    onClick: (data, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Upload Site',
                modalWidth: '64rem',
                modalHeight: 'auto',
                modalComponent: <BulkUploadModal type={'LOCATION_CREATE'} />

            })
        );
    },
};

const archivedOrViewAllAssets = {
    key: 'archived_view_or_all_assets',
    conditionalRendering: (item, dispatch, { isArchiveAssetSelected }) => {
        if (isArchiveAssetSelected) return { menuName: 'View All Assets', menuIcon: 'arrow_back' };
        return { menuName: 'Archived Assets', menuIcon: 'archive' };
    },
    onClick: (item, dispatch, { goToAssetTab, setIsArchiveAssetSelected, isArchiveAssetSelected }) => {
        setIsArchiveAssetSelected(!isArchiveAssetSelected);
        let isArchive = false;
        if (!isArchiveAssetSelected) isArchive = true;
        goToAssetTab('', isArchive);
    },
};

const isToOpenBulkActions = ({ selectedData }) => {
    let isItemsSelected = Array.isArray(selectedData) && selectedData.length > 0;
    let toastErrorMsg = 'Please select atleast one';
    let openModal = isItemsSelected;
    return { toastErrorMsg, openModal };
};

const categorizeAssets = {
    key: 'bulk_categorize_assets',
    menuName: 'Categorize Assets',
    menuIcon: 'category',
    onClick: (item, dispatch, { getSelectedData, customerId, defaultEmail, siteId }) => {
        let selectedData = getSelectedData();
        let { openModal, toastErrorMsg } = isToOpenBulkActions({ selectedData });
        let selectedCount = selectedData?.filter((asset) => asset.is_categorised === 0)?.length;
        if (openModal) {
            return dispatch(
                openCustomModal({
                    heading: 'Bulk Categorise Asset',
                    modalWidth: '60rem',
                    modalHeight: 'auto',
                    selectedCount,
                    modalComponent: <EditCategoriseAsset modalData={{ assetslist: selectedData }} customerId={customerId} siteId={siteId} />,
                })
            );
        } else {
            dispatch(sendToastMessage({ status: 'danger', message: toastErrorMsg }));
        }
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const bulkMigrateAsset = {
    key: 'bulk_migrate_assets',
    menuName: 'Migrate Assets',
    menuIcon: 'move_up',
    onClick: (item, dispatch, { getSelectedData, customerId, siteId, warehouseId }) => {
        let selectedData = getSelectedData();
        const allowed = selectedData?.filter((asset) => canAssetMigrate(asset?.status));
        let { openModal, toastErrorMsg } = isToOpenBulkActions({ selectedData });
        if (!siteId) siteId = allowed?.[0]?.id;
        if (!warehouseId) warehouseId = allowed?.[0]?.id;
        if (openModal) {
            return dispatch(
                openCustomModal({
                    heading: 'Bulk Migrate Assets',
                    modalWidth: '85rem',
                    modalHeight: 'auto',
                    selectedCount: allowed.length,
                    modalComponent: <MigrateAsset isBulk modalData={{ assetslist: allowed }} warehouseId={warehouseId} siteId={siteId} />,
                })
            );
        } else {
            dispatch(sendToastMessage({ status: 'danger', message: toastErrorMsg }));
        }
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const releaseAssets = {
    menuName: 'Release Assets',
    menuIcon: 'highlight_off ',
    onClick: () => {
        alert('Release Assets');
    },
};

const bulkScrapAsset = {
    key: 'bulk_scrap_assets',
    menuName: 'Scrap Assets',
    menuIcon: 'highlight_off',
    onClick: (item, dispatch, { getSelectedData, customerId, defaultEmail, customerIdOfSelectedSite, siteId, warehouseId, tabName }) => {
        let selectedData = getSelectedData();
        let { openModal, toastErrorMsg } = isToOpenBulkActions({ selectedData });
        if (openModal) {
            return dispatch(
                openCustomModal({
                    heading: 'Scrap Assets',
                    modalWidth: '45rem',
                    modalHeight: 'auto',
                    selectedCount: selectedData?.length,
                    modalComponent: (
                        <ScrapAsset
                            modalData={{ assetslist: selectedData }}
                            customerId={customerId}
                            customerIdOfSelectedSite={customerIdOfSelectedSite}
                            warehouseId={warehouseId}
                            siteId={siteId}
                            modalName={tabName}
                        />
                    ),
                })
            );
        } else {
            dispatch(sendToastMessage({ status: 'danger', message: toastErrorMsg }));
        }
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const bulkApproveRmaSupport = {
    key: 'bulk_approve_rma_support',
    menuName: 'Bulk Approve RMA Support',
    menuIcon: 'list',
    onClick: (item, dispatch, { getSelectedData, customerId, siteId }) => {
        let selectedData = getSelectedData();
        let { openModal, toastErrorMsg } = isToOpenBulkActions({ selectedData });
        if (openModal) {
            return dispatch(
                openCustomModal({
                    heading: 'Approve RMA Support',
                    modalWidth: '64rem',
                    modalHeight: 'auto',
                    modalComponent: (
                        <ApproveRmaSupport modalData={{ assetslist: selectedData }} customerId={customerId} rmaEligibility={'RMA_ELIGIBILITY_APPROVE'} siteId={siteId} />
                    ),
                })
            );
        } else {
            dispatch(sendToastMessage({ status: 'danger', message: toastErrorMsg }));
        }
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const addAssetTypes = {
    key: 'add_asset_types',
    menuName: 'Add New Asset Type',
    menuIcon: 'add',
    onClick: (item, dispatch, { siteId, customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Add Asset Type',
                modalWidth: '50rem',
                modalHeight: 'auto',
                modalComponent: <AddAssetTypes customerId={customerId} type='assets' siteId={siteId} />,
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const bulkUploadAsset = {
    key: 'bulk_upload_asset',
    menuName: 'Bulk Upload Asset',
    menuIcon: 'backup',
    onClick: (data, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Upload Asset',
                modalWidth: '64rem',
                modalHeight: 'auto',
                modalComponent: <BulkUploadModal type={'ASSET_CREATE'} site_type='SITE' />
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const bulkAssetConfigCreation = {
    key: 'bulk_asset_config_creation',
    menuName: 'Bulk Asset Config',
    menuIcon: 'tune',
    onClick: (_, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Asset Config',
                modalWidth: '64rem',
                modalHeight: 'auto',
                modalComponent: <BulkUploadModal type={'ASSET_CONFIG_CREATE'} />
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const bulkUploadAssetWarehouse = {
    key: 'bulk_upload_asset',
    menuName: 'Bulk Upload Spare Asset',
    menuIcon: 'backup',
    onClick: (data, dispatch, { customerId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Upload Spare Asset',
                modalWidth: '64rem',
                modalHeight: 'auto',
                modalComponent: <BulkUploadModal type={'SPARE_ASSET_CREATE'} site_type='WAREHOUSE' />
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

const bulkUploadSpareAssetModal = {
    key: 'bulk_upload_spareasset',
    menuName: 'Bulk Upload Spare Asset',
    menuIcon: 'backup',
    onClick: (data, dispatch, { customerId, wareHouseId }) => {
        return dispatch(
            openCustomModal({
                heading: 'Bulk Upload Spare Asset',
                modalWidth: '64rem',
                modalHeight: 'auto',
                modalComponent: (
                    <UploadFile
                        customerId={customerId}
                        uploadFileAction={bulkUploadSpareAssets}
                        type={spareAssets.id}
                        filename={'bulk_upload_spare_asset_sample'}
                        warehouseId={wareHouseId}
                        showCustomerDropdown
                    />
                ),
            })
        );
    },
};

const downloadReport = {
    key: 'download_report',
    menuName: 'Download Report',
    imgIcon: '/img/csvdownload.png',
    onClick: (_, dispatch, { getSelectedData, siteId }) => {
        let selectedData = getSelectedData();
        let filterData = {};
        const urlParams = new URLSearchParams(window.location.search);
        const tab = urlParams.get('tab');
        let report = ReportsName.INVENTORY_LOCATION;
        if (tab === spareAssets.path || tab === assets.path) {
            report = ReportsName.INVENTORY_ASSET;
            let asset_ids = selectedData?.map((elem) => elem.asset_id);
            if (asset_ids?.length > 0) filterData.asset_ids = asset_ids
        } else {
            report = ReportsName.INVENTORY_LOCATION;
            let location_ids = selectedData?.map((elem) => elem.id);
            if (location_ids?.length > 0) filterData.location_ids = location_ids;
        }

        return dispatch(
            openCustomModal({
                heading: ' Download Sample File(CSV)',
                modalWidth: '60rem',
                modalHeight: 'auto',
                modalComponent: (
                    <RequestStatement report={report} filterData={filterData} />
                ),
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};

export const getAssetTitle = (asset) => {
    return `${asset.asset.asset_number ? asset.asset.asset_number : asset.asset.external_id}`;
};

const getBulkSitesActions = ({ inventoryPermissions, newLoggedUserData }) => {
    inventoryPermissions = inventoryPermissions.locations;
    let actions = [addAssetTypes, downloadReport, bulkUploadSite, bulkUploadAsset, bulkAssetConfigCreation];

    actions = actions.filter((action) => {
        switch (action.key) {
            case bulkUploadSite.key: {
                return canCreateInventoryLocation(newLoggedUserData.actions);
            }
            case addAssetTypes.key:
            case bulkUploadAsset.key:
            case bulkAssetConfigCreation.key: {
                return canCreateInventoryAsset(newLoggedUserData.actions);
            }
            default:
                return true;
        }
    });
    return actions;
};

const getBulkAssetsActions = ({ inventoryPermissions, newLoggedUserData }) => {
    inventoryPermissions = inventoryPermissions.assets;
    let actions = [addAssetTypes, bulkMigrateAsset, bulkUploadAsset, bulkAssetConfigCreation, downloadBulkQR, downloadReport];

    actions = actions.filter((action) => {
        switch (action.key) {

            case downloadBulkQR.key:
            case addAssetTypes.key: {
                return canCreateInventoryAsset(newLoggedUserData.actions);
            }
            case bulkMigrateAsset.key: {
                return inventoryPermissions.includes(InventoryActions.MIGRATE_ASSET);
            }
            case bulkUploadAsset.key: {
                return canCreateInventoryAsset(newLoggedUserData.actions);
            }
            case bulkAssetConfigCreation.key: {
                return canCreateInventoryAsset(newLoggedUserData.actions);
            }

            default:
                return true;
        }
    });

    return actions;
};

const getBulkWarehouseActions = ({ inventoryPermissions, newLoggedUserData }) => {
    inventoryPermissions = inventoryPermissions.locations;
    let actions = [addAssetTypes, bulkMigrateAsset, bulkUploadAssetWarehouse, bulkAssetConfigCreation, downloadReport];
    actions = actions.filter((action) => {
        switch (action.key) {
            case addAssetTypes.key: {
                return canCreateInventoryAsset(newLoggedUserData.actions);
            }
            case bulkUploadAssetWarehouse.key: {
                return canCreateInventoryLocation(newLoggedUserData.actions);
            }
            case bulkAssetConfigCreation.key: {
                return canCreateInventoryAsset(newLoggedUserData.actions);
            }
            case bulkMigrateAsset.key: {
                return inventoryPermissions.includes(InventoryActions.MIGRATE_ASSET);
            }
            default:
                return true;
        }
    });
    return actions;
};

const getBulkSpareAssetsActions = ({ inventoryPermissions, newLoggedUserData }) => {
    inventoryPermissions = inventoryPermissions.assets;
    let actions = [addAssetTypes, downloadBulkQR, bulkMigrateAsset, bulkUploadAssetWarehouse, bulkAssetConfigCreation, downloadReport];
    actions = actions.filter((action) => {
        switch (action.key) {
            case addAssetTypes.key: {
                return canCreateInventoryAsset(newLoggedUserData.actions);
            }
            case bulkMigrateAsset.key: {
                return inventoryPermissions.includes(InventoryActions.MIGRATE_ASSET);
            }
            case bulkUploadAssetWarehouse.key: {
                return canCreateInventoryLocation(newLoggedUserData.actions);
            }
            case bulkAssetConfigCreation.key: {
                return canCreateInventoryAsset(newLoggedUserData.actions);
            }
            default:
                return true;
        }
    });
    return actions;
};

export const sites = { title: 'Site Details', id: 'site', singular: 'Site', path: 'sites', getBulkActions: getBulkSitesActions };
export const assets = { title: 'Asset Details', id: 'asset', singular: 'Asset', path: 'assets', getBulkActions: getBulkAssetsActions };
export const warehouses = {
    title: 'Warehouse Details',
    id: 'warehouse',
    singular: 'Warehouse',
    path: 'warehouse',
    getBulkActions: getBulkWarehouseActions,
};
export const spareAssets = {
    title: 'Spare Assets Details',
    id: 'spareasset',
    singular: 'Spare Asset',
    path: 'spareAssets',
    getBulkActions: getBulkSpareAssetsActions,
};

const sitesTab = {
    tabName: 'Sites',
    subTabs: [sites, assets],
    tabIcon: 'people_alt',
    iconSize: 'text-3xl',
};

const sparesTab = {
    tabName: 'Spares',
    subTabs: [warehouses, spareAssets],
    tabIcon: 'people_alt',
    iconSize: 'text-3xl',
};


const downloadQR = {
    key: 'download_qr_code',
    menuName: 'Download QR Code',
    menuIcon: 'qr_code_2',
    onClick: (asset, dispatch) => {
        return dispatch(
            openCustomModal({
                heading: 'Download QR Code',
                modalWidth: isMobileView ? '36rem' : '50rem',
                modalHeight: 'auto',
                modalComponent: <DownloadQR asset={asset} />,
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};


const downloadBulkQR = {
    key: 'download_qrcodes',
    menuName: 'Download QR Codes',
    menuIcon: 'qr_code_2',
    onClick: (asset, dispatch, { getSelectedData, }) => {
        let selectedData = getSelectedData();
        const assets = selectedData.map((asset) => asset.asset_id);
        return dispatch(
            openCustomModal({
                heading: 'Download QR Codes',
                modalWidth: '45rem',
                modalHeight: 'auto',
                selectedCount: selectedData.length,
                modalComponent: (
                    <DownloadBulkQR assets={assets} />
                ),
            })
        );
    },
    isDisabled: () => {
        return { disabled: false, message: '' };
    },
};



///// 

export const InventoryActions = {
    EDIT_LOCATION: 'EDIT_LOCATION',
    DELETE_LOCATION: 'DELETE_LOCATION',

    CREATE_ASSET_AT_LOCATION: 'CREATE_ASSET_AT_LOCATION',
    CREATE_ASSET_AT_WAREHOUSE: 'CREATE_ASSET_AT_WAREHOUSE',

    EDIT_ASSET: 'EDIT_ASSET',
    DELETE_ASSET: 'DELETE_ASSET',
    MIGRATE_ASSET: 'MIGRATE_ASSET',
}

export const canEditLocation = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === InventoryActions.EDIT_LOCATION);
    return (hasPermission && hasPermission.allowed);
}

export const canDeleteLocation = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === InventoryActions.DELETE_LOCATION);
    return (hasPermission && hasPermission.allowed);
}

export const canCreateAssetAtLocation = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === InventoryActions.CREATE_ASSET_AT_LOCATION);
    return (hasPermission && hasPermission.allowed);
}

export const canCreateAssetAtWarehouse = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === InventoryActions.CREATE_ASSET_AT_WAREHOUSE);
    return (hasPermission && hasPermission.allowed);;
}

export const canEditAsset = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === InventoryActions.EDIT_ASSET);
    return (hasPermission && hasPermission.allowed);
}

export const canDeleteAsset = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === InventoryActions.DELETE_ASSET);
    return (hasPermission && hasPermission.allowed);
}

export const canMigrateAsset = (actions = []) => {
    const hasPermission = actions.find(({ action }) => action === InventoryActions.MIGRATE_ASSET);
    return (hasPermission && hasPermission.allowed);
}

const isCurrentOrgOwner = (newLoggedUserData) => {
    return newLoggedUserData?.orgMemberships?.some((membership) => {
        const role = membership?.role;
        return membership?.id === newLoggedUserData?.org?.id && role?.toUpperCase() === 'OWNER';
    });
};



export const getSitesTableActions = (location, newLoggedUserData) => {
    let actions = [editSite, addAsset, deleteSiteModal];
    return actions.filter((action) => {

        switch (action.key) {

            case editSite.key:  // Edit Location
                return canEditLocation(location.actions) || isCurrentOrgOwner(newLoggedUserData);

            case addAsset.key:  // Create Asset at Location
                return canCreateInventoryAsset(newLoggedUserData.actions);

            case deleteSiteModal.key:  // Delete Location
                return canDeleteLocation(location.actions);

            default:
                return true;
        }
    });
};


export const getWarehouseTableActions = (location, newLoggedUserData) => {
    let actions = [editWarehouse, addSpareAsset, deleteWarehouseModal];
    return actions.filter((action) => {

        switch (action.key) {
            case editWarehouse.key:  // Edit Warehouse
                return canEditLocation(location.actions) || isCurrentOrgOwner(newLoggedUserData);

            case addSpareAsset.key:  // Create Spare Asset
                return canCreateInventoryAsset(newLoggedUserData.actions);

            case deleteWarehouseModal.key:  // Delete Warehouse
                return canDeleteLocation(location.actions) || isCurrentOrgOwner(newLoggedUserData);


            default:
                return true;
        }
    });
};


export const getAssetsTableActions = (asset, newLoggedUserData) => {
    const actions = [viewAssetConfig, viewPavData, editAsset, migrateAsset, downloadQR, deleteAssetData];
    return actions.filter((action) => {
        switch (action.key) {
            case viewAssetConfig.key:
                return canCreateInventoryAsset(newLoggedUserData.actions);

            case editAsset.key:
                return canEditAsset(asset.actions);

            case migrateAsset.key:
                return canMigrateAsset(asset.actions) && asset.status === 'AVAILABLE';

            case deleteAssetData.key:
                return canDeleteAsset(asset.actions);

            case downloadQR.key:
                return newLoggedUserData.user.roles.some((role) => [TicketAgentRole.SCM, TicketAgentRole.CUSTOMER].includes(role.label.toUpperCase()));

            default:
                return true;
        }
    });


};

export const getSpareTableActions = (spareAsset, newLoggedUserData) => {
    const actions = [viewAssetConfig, viewPavData, editAssetModal, migrateAsset, downloadQR, deleteSpareAssetModal];
    return actions.filter((action) => {
        switch (action.key) {
            case viewAssetConfig.key:
                return canCreateInventoryAsset(newLoggedUserData.actions);

            case editAssetModal.key:
                return canEditAsset(spareAsset.actions);

            case migrateAsset.key:
                return canMigrateAsset(spareAsset.actions) && spareAsset.status === 'AVAILABLE';

            case deleteSpareAssetModal.key:
                return canDeleteAsset(spareAsset.actions);

            // case editAssetConfig.key:
            //     return canEditAsset(spareAsset.actions);


            case downloadQR.key:
                return newLoggedUserData.user.roles.some((role) => [TicketAgentRole.SCM, TicketAgentRole.CUSTOMER].includes(role.label.toUpperCase()));

            default:
                return true;
        }
    });
};


const canAssetMigrate = (status) => {
    return status === 'AVAILABLE';
};

export const isDeviceConfigurationRequired = (asset) => {
    return asset.assetType?.device_config_required;
}


const canModifyWarehouse = (loggedUserId, warehouseUserId) => {
    return loggedUserId === warehouseUserId || warehouseUserId === 0;
};

export const getInventoryMainTabs = (inventoryTabs = []) => {
    if (inventoryTabs.length === 0) return [];
    let tabs = [sitesTab, sparesTab];
    tabs = tabs.filter((tab) => {
        tab.subTabs = tab.subTabs.filter((subTab) => {
            let find = inventoryTabs.find((inventoryTab) => inventoryTab.key === subTab.id);
            if (find) {
                subTab.title = find.label;
            }
            return find ? subTab : false;
        })
        return tab.subTabs.length > 0 ? tab : false;
    });
    return tabs;
};

export const getInventoryDefaultTab = (tabs, urlQueryString) => {
    if (tabs.length === 0) return {};
    let tab = tabs[0],
        subTab = tab.subTabs[0];
    if (urlQueryString) {
        const { matchingTab, matchingSubTab } = getTabFromQueryString(tabs, urlQueryString);
        if (matchingTab) {
            tab = matchingTab;
            subTab = matchingSubTab;
        }
    }
    return { rootTab: tab.tabName, subTab: subTab.path };
};

const getTabFromQueryString = (tabs, urlQueryString) => {
    const match = urlQueryString.match(/[\?&]tab=(\w+)/);
    let queryTab;
    if (match) queryTab = match[1];
    const matchingTab = tabs.find((tab) => tab.subTabs.find((subTab) => subTab.path === queryTab));
    if (matchingTab) {
        const matchingSubTab = matchingTab.subTabs.find((subTab) => subTab.path === queryTab);
        return { matchingTab, matchingSubTab };
    }
    return {};
};

const getInventoryBulkActionButton = (role, type) => {
    if (isScm(role, type) || isCustomerAdmin(role, type) || isCustomer(role, type) || isCluster(role, type) || isSuperVisor(role, type)) return true;
    else return false;
};

const getInventoryAddNewButton = (role, type) => {
    if (isScm(role, type) || isCustomerAdmin(role, type) || isCustomer(role, type)) return true;
    else return false;
};

export const GetInventoryActions = (logic, { asset, spareAsset, warehouse, tabName, urlQueryString } = {}) => {
    const { loggedUser } = useSelector((state) => state.auth);
    const role = loggedUser.role.id,
        type = loggedUser.type,
        userId = loggedUser.id,
        frontend_controller = loggedUser.frontend_controller;
    if (logic === 'assetsTableActions') return getAssetsTableActions(role, type, asset);
    if (logic === 'spareTableActions') return getSpareTableActions(role, type, frontend_controller);
    if (logic === 'tabs') return getInventoryMainTabs(role, type);
    if (logic === 'defaultTab') return getInventoryDefaultTab(role, type, { urlQueryString });
    if (logic === 'bulkActionButton') return getInventoryBulkActionButton(role, type);
    if (logic === 'addNewButton') return getInventoryAddNewButton(role, type, tabName);
    if (logic === 'isToShowCustomerData') return isScm(role, type);
    return [];
};

export const InventoryFormFields = (fieldName) => {
    const { loggedUser } = useSelector((state) => state.auth);
    const role = loggedUser.role.id,
        type = loggedUser.type;
    if (fieldName === 'addNewSiteCustomerField' || fieldName === 'addNewWarehouseCustomerField' || fieldName === 'addNewSpareAssetCustomerField') return isScm(role, type);
    if (fieldName === 'isToShowAddNewWarehouseDetails') return isCustomer(role, type);
    if (fieldName === 'downloadBulkQRCustomerField') return isScm(role, type);

    return false;
};

export const InventoryTableDetailsFields = (fieldName) => {
    const { loggedUser } = useSelector((state) => state.auth);
    const role = loggedUser.role.id,
        type = loggedUser.type;
    if (fieldName === 'customerCompanyNameInWarehouseTable') return isScm(role, type);
    return false;
};

export const defaultRowsPerPage = 10;
export const defaultPage = 1;



// ----------------------------------------New Logic----------------------------------------






export const InventoryLocationType = {
    SITE: "SITE",
    WAREHOUSE: "WAREHOUSE"
}
